import OpenRehearsal from "../components/events/OpenRehearsal";

export default function EventPage3 () {

    return (
        <>
        <OpenRehearsal/>
        </>
    )
}